import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "service-order-list" }

import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {
  XrkTable,
  XrkTableProps,
  useTableColumn,
  BaseButton
} from 'xrk-components';
import { getServiceCol } from '../fields/columns';
import { getServiceSearch } from '../fields/searchs';

import {
  serviceFeeList,
  orderExport,
  batchDownload
} from '../data-source/apis';


export default /*#__PURE__*/_defineComponent({
  __name: 'individual-proxy-fee-list',
  setup(__props) {

const route = useRoute();
const router = useRouter();

// 搜索项
const searchConfig = ref<XrkTableProps['searchConfig']>({
  searchBtn: {
    show: true,
    text: '搜索'
  },
  resetBtn: {
    show: true,
    text: '重置',
    beforeReset: () => {
      // 清除路由上的查询参数
      if (route.query.orderNo) {
        router.replace({
          query: { force: Date.now() }
        });
      }
    }
  },
  searchColumns: [...getServiceSearch(route.query.orderNo)],
  otherComponents: [
    {
      render() {
        return (
          <>
            {
              <BaseButton
                type="primary2"
                click={async () => {
                  await batchDownload({
                    downloadType: 901,
                    queryParam: JSON.stringify(searchedParams.value)
                  });
                }}
              >
                批量下载回单
              </BaseButton>
            }
            <BaseButton
              type="primary2"
              click={async () => {
                await orderExport({
                  exportType: 8001,
                  reqParam: searchedParams.value
                });
              }}
            >
              导出
            </BaseButton>
          </>
        );
      }
    }
  ].filter(Boolean)
});

// 列表
const tableConfig = ref<XrkTableProps['tableConfig']>({
  tableColumns: [
    useTableColumn({
      type: 'index',
      label: '序号'
    }),
    ...getServiceCol()
  ].filter(Boolean),
  baseConfig: {}
});
const searchedParams = ref({});

const getListAjax = async params => {
  const [orderStartTime, orderEndTime] = params.orderTime || ['', ''];
  const [orderPayStartTime, orderPayEndTime] = params.orderPayTime || ['', ''];

  const reqData = {
    ...params,
    orderStartTime,
    orderEndTime,
    orderPayStartTime,
    orderPayEndTime
  };
  const data = await serviceFeeList(reqData);
  searchedParams.value = reqData;
  return data;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(XrkTable), {
      ref: "xrkTableRef",
      getListAjax: getListAjax,
      searchConfig: searchConfig.value,
      tableConfig: tableConfig.value
    }, null, 8, ["searchConfig", "tableConfig"])
  ]))
}
}

})